import type { ThemeName } from '@bn-games/theming';
import { pageLanguage, type Language } from '@bn-games/i18n-core';
import type { ClockPreset } from '../game/clock.js';

export type Difficulty = 'easy' | 'normal' | 'hard' | 'expert';
export type DefaultColor = 'white' | 'black' | 'random';
export type { ThemeName, Language, ClockPreset };

export const DIFFICULTIES: readonly Difficulty[] = ['easy', 'normal', 'hard', 'expert'];
export const DEFAULT_COLORS: readonly DefaultColor[] = ['white', 'black', 'random'];
export const THEME_NAMES: readonly ThemeName[] = ['mahogany', 'persian', 'deco', 'monte'];
export const LANGUAGES: readonly Language[] = ['en', 'ru'];

export interface Settings {
  readonly sound: boolean;
  readonly difficulty: Difficulty;
  readonly defaultColor: DefaultColor;
  readonly theme: ThemeName;
  readonly language: Language;
  readonly showValidMoves: boolean;
  /** The SAN move list beside or under the board; the icon next to the gear flips it. */
  readonly showMoveList: boolean;
  readonly playerName: string;
  /** Hot-seat only: turn the board to face whoever moves next. */
  readonly flipBoard: boolean;
  readonly afkAssistEnabled: boolean;
  readonly afkTimeoutMs: number;
  readonly afkRemindersEnabled: boolean;
  readonly showAfkPingButton: boolean;
  /** Plays a short cue when the turn comes back to me (vs-Bot + online only). */
  readonly turnStartSound: boolean;
  readonly clockEnabled: boolean;
  readonly clockPreset: ClockPreset;
}

export const DEFAULT_SETTINGS: Settings = {
  sound: true,
  difficulty: 'normal',
  defaultColor: 'white',
  theme: 'mahogany',
  // A /…/ru/ page opens in Russian unless the player already chose a language.
  language: pageLanguage(),
  showValidMoves: true,
  showMoveList: true,
  playerName: 'Player',
  flipBoard: false,
  afkAssistEnabled: true,
  afkTimeoutMs: 10_000,
  afkRemindersEnabled: true,
  showAfkPingButton: true,
  turnStartSound: true,
  clockEnabled: false,
  clockPreset: 'blitz',
};
